import omit from 'lodash/omit';
import { useNavigate } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';

import CustomCheckbox from '../common/CustomCheckbox';
import CustomSelect from '../common/CustomSelect';
import FindPatientForm from '../patients/FindPatientForm';
import SelectProviderInput from '../providers/SelectProviderInput';
import {getClaimStatuses} from '../../helpers/selectOptions';

export const SortButton = () => {
  return <></>;
};

const CaseFilters = props => {
  const {filters} = props;
  const navigate = useNavigate();
  return (
    <Stack direction='row' spacing={{xs: 1.25, md: 3.65}} paddingTop={1.5} paddingBottom={1.5} fullWidth>
        <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={1}>
          <Box style={{minWidth: '200px'}}>
            <FindPatientForm
              rounded={true}
              defaultValue={filters?.patient_id}
              allPatients={false}
              fullWidth={true}
              color='primary'
              onSubmit={({patientId}) => {
                let _filters = (
                  patientId
                  ? {...filters, patient_id: patientId}
                  : omit(filters, 'patient_id')
                );
                props.onFilterChange(_filters);
              }}
            />
          </Box>
          {
            filters.provider_id
            ? <Chip
              label='Filtering by Provider'
              onDelete={() => props.onFilterChange(omit(filters, 'provider_id'))}
              deleteIcon={<CloseIcon />}
              style={{minWidth: '200px'}}
            />
            : <SelectProviderInput
              label={null}
              placeholder='Filter by Provider'
              defaultValue={filters?.provider_id}
              style={{minWidth: '200px'}}
              onChange={e =>
                e.target.value
                ? props.onFilterChange({...filters, provider_id: e.target.value})
                : props.onFilterChange(omit(filters, 'provider_id'))
              }
            />
          }
          {
            !filters.status 
            ? <CustomSelect
              placeholder='Filter by Status'
              options={getClaimStatuses()}
              style={{minWidth: '200px'}}
              onChange={e => props.onFilterChange({...filters, status: e.target.value})}
            />
            : <Chip 
              label={getClaimStatuses().find(s => s.value === filters.status)?.label || 'All'}
              onDelete={() => props.onFilterChange(omit(filters, 'status'))}
              deleteIcon={<CloseIcon />}
              style={{minWidth: '200px'}}
            />
          }
          <CustomCheckbox
            label='Show Unpaid Only'
            checked={filters.unpaid || false}
            onChange={e => props.onFilterChange(
              e.target.checked
              ? {...filters, unpaid: e.target.checked}
              : omit(filters, 'unpaid')
            )}
          />
        </Stack>
    </Stack>
  );
};

export default CaseFilters;